import "./GeneralFindings.css";
import React, { useState } from "react";
import GeneralFindingsTable from "./GeneralFindingsTable";
import FetchMultiSelector from "../CharacteristicsComponents/FetchMultiSelector";
import MultiSelector from "../MultiSelector";
import Efficiency from "./Efficiency";

function groupObjectsByCriterion(objects, key) {
  const groups = new Map();

  objects.forEach((obj) => {
    const value = obj[key];
    if (!groups.has(value)) {
      groups.set(value, []);
    }
    groups.get(value).push(obj);
  });

  return Array.from(groups.values());
}

let yearsItems = {
  title: "",
  options: [
    { key: "2012" },
    { key: "2013" },
    { key: "2014" },
    { key: "2015" },
    { key: "2016" },
    { key: "2017" },
    { key: "2018" },
    { key: "2019" },
    { key: "2020" },
    { key: "2021" },
    { key: "2022" },
    { key: "2023" },
  ],
};

function GeneralFindings() {
  const [selectedOption1, setSelectedOption1] = useState("");
  const [selectedOption2, setSelectedOption2] = useState("");
  const [columns, setColumns] = useState(null); // Initialize columns as null
  const [full_data, setFullData] = useState([]);
  const [airportCodes, setAirportCodes] = useState([]); // Define airportCodes state

  const handleSubmit = (e) => {
    e.preventDefault();

    const airportCodes = selectedOption2.map((airport) => airport.slice(-3));

    var url = "/api/data_efficiency/";
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        years: selectedOption1,
        airport_codes: airportCodes,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        // Handle the response data
        var fullData = data.data.data;
        fullData.sort((a, b) => a["Έτος"] - b["Έτος"]);

        const groupedData = groupObjectsByCriterion(fullData, "Έτος");
        setColumns(Object.keys(fullData[0]));
        setFullData(groupedData);
        setAirportCodes(airportCodes); // Update airportCodes state
      })
      .catch((error) => {
        // Handle any errors
        console.error(error);
      });
  };

  return (
    <div className="page" style={{ marginTop: "50px" }}>
      Γενικά Ευρήματα
      <div
        className="myform"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ marginRight: "50px", width: "500px" }}>
          Επιλογή έτους
          <MultiSelector
            passData={setSelectedOption1}
            props={yearsItems}
            selectionsLimit={-1}
          ></MultiSelector>
        </div>

        <div style={{ width: "500px" }}>
          Επιλογή πλήθους γραμμών DMU
          <FetchMultiSelector
            passData={setSelectedOption2}
          ></FetchMultiSelector>
        </div>
      </div>
      <button
        type="submit"
        onClick={handleSubmit}
        style={{
          marginLeft: "105px",
          backgroundColor: "#0F8DD6",
          color: "white",
        }}
      >
        Αναζήτηση
      </button>
      {full_data.map((table, index) => (
        <GeneralFindingsTable
          key={index}
          data={table}
          columns={columns}
          airports={selectedOption2}
        />
      ))}
      {full_data.length > 0 && (
        <Efficiency
          selectedyears={selectedOption1}
          airports={selectedOption2}
        />
      )}
    </div>
  );
}

export default GeneralFindings;
